import React from 'react';
import { Box } from '@mui/material';

const OuterContainer = ({ children }) => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundColor: '#F6FAFF',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      }}>
      {children}
    </Box>
  );
};

export default OuterContainer;